// Shared TypeScript types for JumpBean
export * from "./referrals.js";
export * from "./admin.js";
export * from "./skills.js";
export * from "./ai-content.js";
export * from "./adaptive.js";
/**
 * Default email preferences for new users
 */
export const DEFAULT_EMAIL_PREFERENCES = {
    marketing: true,
    product_updates: true,
    tips_and_tricks: true,
    sequences: true,
    frequency: "normal",
    paused_until: null,
};
/**
 * Default user settings
 */
export const DEFAULT_USER_SETTINGS = {
    sound: {
        masterVolume: 100,
        musicEnabled: true,
        effectsEnabled: true,
        voiceEnabled: true,
    },
    display: {
        highContrast: false,
        textSize: "normal",
        reduceMotion: false,
    },
    notifications: {
        weeklyReports: true,
        achievements: true,
        reminders: false,
    },
};
/**
 * Default empty stars by discipline
 */
export const EMPTY_STARS_BY_DISCIPLINE = {
    math: 0,
    spelling: 0,
    patterns: 0,
    typing: 0,
    programming: 0,
};
//# sourceMappingURL=index.js.map